import { useDocumentGetS3FieldApi } from './api';

export const useDocumentsGetS3Url = () => {
  const response = useDocumentGetS3FieldApi({
    field: 'url',
  });
  return response;
};
